



export default function Content({mesContent}){

    return( <p  className='pl-1'>{mesContent}</p>)
}